import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import onboardingTemplateService from '../../services/onboardingTemplates/onboardingTemplateService';
import updateOnboardingTemplateService from '../../services/onboardingTemplates/updateOnboardingTemplateService';
import OnboardingTemplateForm from './OnboardingTemplateForm';
import { COMMUNITY_DETAIL_TABS } from '../../constants';
import { mapFormToOnboardingTemplate } from '../../helpers/mapFormToOnboardingTemplate';
import { mapOnboardingTemplateToForm } from '../../helpers/mapOnboardingTemplateToForm';

const EditOnboardingTemplate = ({
  open,
  dispatchUpdateOnboardingTemplatePut,
  updateOnboardingTemplateFetch,
  dispatchOnboardingTemplateGet,
  onboardingTemplateFetch,
}) => {
  const { t } = useTranslation();
  const { id, actionId } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateOnboardingTemplatePut(
        actionId,
        mapFormToOnboardingTemplate(body, id),
        () => history.push(`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`),
        undefined,
        t
      ),
    [id, actionId, dispatchUpdateOnboardingTemplatePut, t]
  );

  useEffect(() => {
    if (open && id) {
      dispatchOnboardingTemplateGet(
        actionId,
        () => history.push(`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`),
        t
      );
    }
  }, [id, actionId, open, t, dispatchOnboardingTemplateGet]);

  const defaultData = useMemo(
    () =>
      !onboardingTemplateFetch.pending &&
      mapOnboardingTemplateToForm(onboardingTemplateFetch.value),
    [onboardingTemplateFetch]
  );

  if (!open || !defaultData?.name) return null;

  return (
    <OnboardingTemplateForm
      header={onboardingTemplateFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateOnboardingTemplateFetch.pending}
      returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`}
      cancelRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`}
      dataLoading={onboardingTemplateFetch.pending}
      data={defaultData}
      showRemoveButton
      editMode
    />
  );
};

EditOnboardingTemplate.propTypes = {
  dispatchUpdateOnboardingTemplatePut: PropTypes.func.isRequired,
  updateOnboardingTemplateFetch: PropTypes.object.isRequired,
  dispatchOnboardingTemplateGet: PropTypes.func.isRequired,
  onboardingTemplateFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditOnboardingTemplate.defaultProps = { open: false };

export default compose(
  onboardingTemplateService,
  updateOnboardingTemplateService
)(EditOnboardingTemplate);
